/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Row, Spinner, Tab, Tabs } from "react-bootstrap";
import ChangePasswordForm from "./components/ChangePasswordForm";
import FDSs from "./components/FDSs";
import Header from "./components/Header";
import HojasTecnicas from "./components/HojasTecnicas";
import LoginForm from "./components/LoginForm";
import RegisterForm from "./components/RegisterForm";
import { useChangePasswordContext } from "./contexts/ChangePasswordContext";
import { useFDSContext } from "./contexts/FDSContext";
import { useLoginContext } from "./contexts/LoginContext";
import { useRegisterContext } from "./contexts/RegisterContext";
import "./css/App.css";
import "./css/formulario.css";

function App() {
	const { loggedIn } = useLoginContext();
	const { registrandose } = useRegisterContext();
	const { fdss } = useFDSContext();
	const { cambiandoPass } = useChangePasswordContext();

	return (
		<div className='App'>
			<Container fluid>
				<Header />
				<Row className='center-all'>
					{!loggedIn && !registrandose && <LoginForm />}
					{registrandose && <RegisterForm />}
					{loggedIn && cambiandoPass && <ChangePasswordForm />}
					{loggedIn && fdss.length === 0 && <Spinner animation='grow' variant='light' />}
					{loggedIn && !cambiandoPass && (
						<Tabs defaultActiveKey='hojasTecnicas' id='uncontrolled-tab-example' className='mb-3'>
							<Tab eventKey='hojasTecnicas' title='HOJAS TÉCNICAS'>
								<HojasTecnicas />
							</Tab>
							<Tab eventKey='fds' title='HOJAS DE SEGURIDAD'>
								<FDSs />
							</Tab>
						</Tabs>
					)}
				</Row>
			</Container>
		</div>
	);
}

export default App;
